export const cleanChannelName = (channelName: string = '') => channelName.replace(/&.+/, '');
